/* Isolated native PO/Note attribute editor. No native cart note or app settings are changed. */
(() => {
  if (window.EmergentNativeFields || !document.querySelector('#main-cart-footer[data-qq-native-footer]') || new URL(location.href).searchParams.has('view')) return;
  const keys = ['PO', 'Note'], latest = new Map(), dirty = new Set();
  let timer, running, failure = false, checkoutPending = false, passSubmit = false;
  const endpoint = new URL(window.Shopify.routes.root + 'cart/update.js', location.origin);
  if (endpoint.origin !== location.origin) return;
  const controls = key => [...document.querySelectorAll('[data-qq-native-field]')].filter(n => n.dataset.qqNativeField === key && n.form?.id === 'cart');
  function bind() {
    for (const key of keys) {
      const nodes = controls(key);
      if (nodes.length !== 1) continue;
      if (!latest.has(key)) latest.set(key, nodes[0].value);
      else if (nodes[0] !== latest.get(key + ':node')) nodes[0].value = latest.get(key);
      latest.set(key + ':node', nodes[0]);
    }
  }
  function capture() {
    bind();
    for (const key of keys) {
      const nodes = controls(key);
      const all = [...document.querySelectorAll('[name="attributes[' + key + ']"]')].filter(n => n.form?.id === 'cart');
      if (nodes.length !== 1 || all.length !== 1 || !nodes[0].checkValidity()) throw new Error('missing_fields');
      if (latest.get(key) !== nodes[0].value) { latest.set(key, nodes[0].value); dirty.add(key); }
    }
  }
  function status(message, failed = false) {
    const box = document.querySelector('[data-qq-native-feedback]');
    const text = document.querySelector('[data-qq-native-status]');
    const retry = document.querySelector('[data-qq-native-retry]');
    if (box) box.hidden = !message;
    if (text && text.textContent !== message) text.textContent = message;
    if (retry) retry.hidden = !failed;
  }
  async function drain() {
    try {
      capture();
      while (dirty.size) {
        const attributes = Object.fromEntries([...dirty].map(key => [key, latest.get(key)]));
        status('Saving cart details…');
        const abort = new AbortController(), timeout = setTimeout(() => abort.abort(), 15000);
        let cart;
        try {
          const response = await fetch(endpoint, {method: 'POST', credentials: 'same-origin', signal: abort.signal,
            headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({attributes})});
          if (!response.ok) throw new Error('save_failed');
          cart = await response.json();
          if (!cart || !cart.attributes || Object.entries(attributes).some(([key, value]) => (cart.attributes[key] ?? '') !== value)) throw new Error('save_failed');
        } finally { clearTimeout(timeout); }
        for (const [key, value] of Object.entries(attributes)) if (latest.get(key) === value) dirty.delete(key);
        capture();
      }
      failure = false;
      status('');
    } catch (error) {
      failure = true;
      status('Cart details could not be saved. Your entries are still here. Retry before continuing.', true);
      throw error;
    }
  }
  function flush() {
    clearTimeout(timer);
    if (!running) running = drain().finally(() => { running = null; });
    return running;
  }
  const schedule = () => { clearTimeout(timer); if (!failure) timer = setTimeout(() => flush().catch(() => {}), 300); };
  document.addEventListener('input', event => {
    const node = event.target, key = node.dataset?.qqNativeField;
    if (!keys.includes(key) || node.form?.id !== 'cart') return;
    latest.set(key, node.value); latest.set(key + ':node', node); dirty.add(key);
    schedule();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches?.('[data-qq-native-field="PO"]')) event.preventDefault();
  });
  document.addEventListener('click', event => {
    if (event.target.closest?.('[data-qq-native-retry]')) { event.preventDefault(); flush().catch(() => {}); }
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.id !== 'cart') return;
    if (passSubmit) { passSubmit = false; return; }
    event.preventDefault();
    if (checkoutPending) return;
    const quote = document.querySelector('emergent-quickquote');
    if (quote?.busy || quote?.nativeSubmissionPending) { status('Finish the current quote preparation before continuing to checkout.'); return; }
    checkoutPending = true;
    const submitter = event.submitter;
    flush().then(async () => {
      await new Promise(resolve => setTimeout(resolve, 0));
      // Read once more immediately before the native submission; no asynchronous gap follows.
      capture();
      if (dirty.size || !form.isConnected || !form.reportValidity()) return;
      passSubmit = true;
      try { form.requestSubmit(submitter?.isConnected ? submitter : undefined); }
      finally { passSubmit = false; }
    }).catch(() => {}).finally(() => { checkoutPending = false; });
  }, true);
  new MutationObserver(bind).observe(document.body, {childList: true, subtree: true});
  bind();
  window.EmergentNativeFields = {flush, get checkoutPending() { return checkoutPending; }};
})();
